import {BasicReducerState, initialReducerState} from "../BasicReducerState";
import {Nullable} from "../../models/common/Nullable";
import {
    errorFetchingRequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";
import {ContractorOffice} from "../../models/contractor/ContractorOffice";
import {
    ContractorOfficeActionTypes,
    FETCH_CONTRACTORS_OFFICES,
    FETCH_CONTRACTORS_OFFICES_ERROR, FETCH_CONTRACTORS_OFFICES_SUCCESS
} from "../../actions/contractors/ContractorOfficeActions";


export interface ContractorOfficeState {
    [ key: number ]: BasicReducerState< Nullable< ContractorOffice[] >, Nullable< ContractorOffice > >
}

export function ContractorOfficeReducer(
    state: ContractorOfficeState = {},
    action: ContractorOfficeActionTypes
) {

    switch (action.type) {
        case FETCH_CONTRACTORS_OFFICES:
            return {
                ...state,
                [ action.contractorId.rawValue ]: {
                    ...state[ action.contractorId.rawValue ],
                    entries: {
                        current: null,
                        request: startFetchingRequestState()
                    },
                }
            };
        case FETCH_CONTRACTORS_OFFICES_SUCCESS:
            return {
                ...state,
                [ action.contractorId.rawValue ]: {
                    ...state[ action.contractorId.rawValue ],
                    totalEntries: action.payload.totalEntries,
                    entries: {
                        current: action.payload.entries,
                        request: successFetchingRequestState()
                    }
                }
            };
        case FETCH_CONTRACTORS_OFFICES_ERROR:
            return {
                ...state,
                [ action.contractorId.rawValue ]: {
                    ...state[ action.contractorId.rawValue ],
                    entries: {
                        ...state[ action.contractorId.rawValue ].entries,
                        request: errorFetchingRequestState(action.error)
                    }
                }

            };
        default:
            return state;
    }
}